module.exports = __webpack_public_path__ + "media/packs/images/flags/AO-b9b17b5a90d5c240e275f1248c235ca1.svg";